import React from "react"

const MovimientosInventarios = ({ apiDateFilter }: { apiDateFilter: string[] | null }) => {
    apiDateFilter
    return <div>MovimientosInventarios</div>
}

export default MovimientosInventarios
